<template>
  <div class="configCrudComp">

    <h2 class="" for="">Бонусы</h2>
    <div>
      <label-hint-comp
        :textLabel="`Макс. процент оплаты, %`"
        :textHint="'Часть стоимости заказа (в процентах), которую пользователь может оплатить бонусными баллами'"
        :showBtn="true"
      />
      <input min="0" max="100" type="number" v-model="data.bonus.max" :class="['input_grey', {'animated shake error_input': errors.max}]" @click="resetError('max')">
      <p class="p_err_min">{{errors.max}}</p>
    </div>

    <div>
      <label-hint-comp
        :textLabel="`Кэшбэк с заказа, %`"
        :textHint="'Часть стоимости заказа (в процентах), которая добавится пользователю в виде бонусных баллов'"
        :showBtn="true"
      />
      <input min="0" max="100" type="number" v-model="data.bonus.cashback" :class="['input_grey', {'animated shake error_input': errors.cashback}]" @click="resetError('cashback')">
      <p class="p_err_min">{{errors.cashback}}</p>
    </div>

  <h2 class="" for="">Информация о компании</h2>
    <div>
      <label class="label_title" for="">Телефон</label>
      <input v-mask="$helpers.input.masks.phone" type="text" v-model="data.company.phone" :class="['input_grey', {'animated shake error_input': errors.phone}]" @click="resetError('phone')">
      <p class="p_err_min">{{errors.phone}}</p>
    </div>
    <div>
      <label class="label_title" for="">Адрес</label>
      <input type="text" v-model="data.company.address" :class="['input_grey', {'animated shake error_input': errors.address}]" @click="resetError('address')">
      <p class="p_err_min">{{errors.address}}</p>
    </div>
    <div>
      <label class="label_title" for="">Адрес эл.почты</label>
      <input v-mask="$helpers.input.masks.phone.email" type="text" v-model="data.company.email" :class="['input_grey', {'animated shake error_input': errors.email}]" @click="resetError('email')">
      <p class="p_err_min">{{errors.email}}</p>
    </div>
    <div>
      <label class="label_title" for="">Адрес сайта</label>
      <input v-mask="$helpers.input.masks.site" type="text" v-model="data.company.site" :class="['input_grey', {'animated shake error_input': errors.site}]" @click="resetError('site')">
      <p class="p_err_min">{{errors.site}}</p>
    </div>

    <br><br>
    <div>
      <label class="label_title" for="">Адрес эл.почты для уведомлений</label>
      <input v-mask="$helpers.input.masks.phone.email" type="text" v-model="data.adminEmail.email" :class="['input_grey']">
      <!-- <p class="p_err_min">{{errors.email}}</p> -->
    </div>

    <br><br>
    <div>
      <label-hint-comp
        :textLabel="`Сообщение в окне таймера ( ${maxTimerMessage - (data.timerMessage ? data.timerMessage.length : 0 )} /  ${maxTimerMessage} )`"
        :textHint="'Укажите в тексте - $tm. В мобильном приложении $tm будет заменен на время ожидания массажа (своё для каждого кресла).'"
        :showBtn="true"
      />
      <textarea v-model="data.timerMessage " :maxlength="maxTimerMessage" cols="10" rows="10" type="text" :class="['textarea_grey_1']"></textarea>
      <p></p>
    </div>

    <br><br>
    <div>
      <label-hint-comp
        :textLabel="`Информация о системе бонусов ( ${maxBonusInfo - (data.bonus.info ? data.bonus.info.length : 0 )} /  ${maxBonusInfo} )`"
        :textHint="''"
        :showBtn="false"
      />
      <!-- <label class="label_title" for="">Информация об бонусах</label> -->
      <textarea v-model="data.bonus.info " :maxlength="maxBonusInfo" cols="10" rows="10" type="text" :class="['textarea_grey_1']"></textarea>
      <p></p>
    </div>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="update"/>
    </div>

    <p class="p_err_main">{{errMain}}</p>
  </div>
</template>

<script>
export default {
  name: 'configCrudComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'config',
      maxTimerMessage: 90,
      maxBonusInfo: 250,
      showHints: {
        timerMessage: false
      }
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/get`, { required: this.required })
  },
  components: {
  },
  computed: {
    data: function () { return this.$store.getters[`${this.moduleName}/getOne`] },
    errMain: function () { return this.$store.getters[`${this.moduleName}/getErrMain`] },
    errors: function () { return this.$store.getters[`${this.moduleName}/getErrors`] }
  },
  methods: {
    setShowHint (hintName) {
      this.showHints[hintName] = !this.showHints[hintName]
    },
    update () {
      this.data.company.phone = this.data.company.phone.replace(/[()_-]/g, '')
      this.$store.dispatch(`${this.moduleName}/update`, { data: this.data })
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    }
  }
}
</script>

<style scoped lang="scss">

.div_hint {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr auto;
  grid-gap: 5px;
  margin-bottom: 10px;
}
.div_hint > label {
  margin: 0 auto 0 0!important;
}
.div_hint > button {
  margin: auto!important;
}

.configCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  margin-top: 20px;
}
.btn_program {
  width: 28px;
  margin: auto 0 auto 5px;
}
.div_programs_title {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto auto 1fr;
}
.div_program {
  margin-bottom: 20px;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .configCrudComp{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
  .configCrudComp label{
    margin: 0 0 10px 0;
  }
  .configCrudComp input{
    margin: 0 0 20px 0;
  }
  .configCrudComp button{
    margin: 12px 0 0 0;
  }
}

</style>
